<div [formGroup]="form">
  <label *ngIf="question.controlType !== 'date'" [attr.for]="question.key">{{question.label}}</label>
  <span *ngIf="question.required && question.controlType !== 'date'" class="mandatory">*</span>
  <div [ngSwitch]="question.controlType">

    <input *ngSwitchCase="'textbox'" [placeholder]="question.placeholder" [formControlName]="question.key"
      [attr.id]="question.key" class="form-control" [type]="question.type" [attr.maxLength]="question.maxLength">

    <input *ngSwitchCase="'textarea_blur'" (blur)="onBlur($event)" [placeholder]="question.placeholder" [formControlName]="question.key"
      [attr.id]="question.key" class="form-control" [type]="question.type" [attr.maxLength]="question.maxLength">

    <select [attr.id]="question.key" *ngSwitchCase="'dropdown'" class="form-control" [formControlName]="question.key">
      <option [ngValue]="null">{{question.placeholder}}</option>
      <option *ngFor="let opt of question.options" [value]="opt.key">{{opt.label}}</option>
    </select>

    <textarea *ngSwitchCase="'textarea'" [placeholder]="question.placeholder" [formControlName]="question.key"
      [attr.id]="question.key" class="form-control" [attr.maxLength]="question.maxLength"></textarea>

    <div *ngSwitchCase="'date'" [mandatory]="question.required" [labelInput]="question.label"
      [placeholder]="question.placeholder" datePickerInput [formControlName]="question.key"></div>

  </div>
</div>
